import { DeepPartial } from '@fullstory/typeutils';
import { AppState, SegmentsById } from '@fullstory/redux';
import { SegmentDefinition, Platform } from '@fullstory/proto/fs/api/segment';
import { int64, timestamp, Duration } from '@fullstory/proto/google/protobuf';
import { mockAuditMetadata } from '../shared/metadata';
import { SegmentDetail } from '@fullstory/proto/fs/services/dx-objects';
import { Visibility } from '@fullstory/proto/fs/gcloud/dstore/protoauditstore';

export const EMPTY_SEGMENT_DEFINITION: SegmentDefinition = {
  userProperties: [],
  excludeUserProperties: [],
  behaviors: [],
  excludeBehaviors: [],
  constraints: {
    inOrder: false,
    inSameSession: false,
    platform: Platform.PLATFORM_INVALID,
    timeRange: null,
    completeSessions: false,
    withinTime: Duration.zero,
    eventThresholds: [],
  },
  excludeConstraints: null,
};

export const newThisWeek: SegmentDetail = {
  segment: {
    segment: {
      id: 'newThisWeek',
      name: 'New this week',
      description: '',
      segmentDefinition: {
        userProperties: [
          {
            primary: {
              firstSeen: {
                range: {
                  value: {
                    startTime: 'NOW/DAY-6DAY',
                    endTime: 'NOW/DAY+1DAY',
                  },
                },
              },
            },
          },
        ],
        excludeUserProperties: [],
        behaviors: [],
        excludeBehaviors: [],
        constraints: {
          inOrder: false,
          inSameSession: false,
          platform: 0,
          timeRange: {
            startTime: 'NOW/DAY-6DAY',
            endTime: 'NOW/DAY+1DAY',
          },
          completeSessions: false,
          withinTime: Duration.zero,
          eventThresholds: [],
        },
        excludeConstraints: null,
      },
    },
    segmentMetadata: {
      canned: true,
    },
    metadata: mockAuditMetadata(),
  },
  starred: true,
  lastViewed: null,
};

export const segmentsById: SegmentsById = {
  everyone: {
    segment: {
      segment: {
        id: 'everyone',
        name: 'Everyone',
        description: '',
        segmentDefinition: {
          userProperties: [],
          excludeUserProperties: [],
          behaviors: [],
          excludeBehaviors: [],
          constraints: {
            inOrder: false,
            inSameSession: false,
            platform: 0,
            timeRange: {
              startTime: 'NOW/DAY-29DAY',
              endTime: 'NOW/DAY+1DAY',
            },
            completeSessions: false,
            withinTime: Duration.zero,
            eventThresholds: [],
          },
          excludeConstraints: null,
        },
      },
      segmentMetadata: {
        canned: true,
      },
      metadata: mockAuditMetadata(),
    },
    starred: false,
    lastViewed: null,
  },
  signedUpUsers: {
    segment: {
      segment: {
        id: 'signedUpUsers',
        name: 'Signed-up',
        description: '',
        segmentDefinition: {
          userProperties: [
            {
              primary: {
                signedUp: {
                  signedUp: {
                    value: true,
                  },
                },
              },
            },
          ],
          excludeUserProperties: [],
          behaviors: [],
          excludeBehaviors: [],
          constraints: {
            inOrder: false,
            inSameSession: false,
            platform: 0,
            timeRange: {
              startTime: 'NOW/DAY-29DAY',
              endTime: 'NOW/DAY+1DAY',
            },
            completeSessions: false,
            withinTime: Duration.zero,
            eventThresholds: [],
          },
          excludeConstraints: null,
        },
      },
      segmentMetadata: {
        canned: true,
      },
      metadata: mockAuditMetadata(),
    },
    starred: true,
    lastViewed: null,
  },
  newThisWeek,
  rageClicks: {
    segment: {
      segment: {
        id: 'rageClicks',
        name: 'Rage clicked recently',
        description: '',
        segmentDefinition: {
          userProperties: [],
          excludeUserProperties: [],
          behaviors: [
            {
              event: {
                primary: {
                  rageClick: {
                    any: {},
                  },
                },
                deps: [],
              },
            },
          ],
          excludeBehaviors: [],
          constraints: {
            inOrder: false,
            inSameSession: false,
            platform: 0,
            timeRange: {
              startTime: 'NOW/DAY-6DAY',
              endTime: 'NOW/DAY+1DAY',
            },
            completeSessions: false,
            withinTime: Duration.zero,
            eventThresholds: [],
          },
          excludeConstraints: null,
        },
      },
      segmentMetadata: {
        canned: true,
      },
      metadata: mockAuditMetadata(),
    },
    starred: true,
    lastViewed: null,
  },
  mobileUsers: {
    segment: {
      segment: {
        id: 'mobileUsers',
        name: 'Mobile',
        description: '',
        segmentDefinition: {
          userProperties: [],
          excludeUserProperties: [],
          behaviors: [
            {
              event: {
                primary: null,
                deps: [
                  {
                    device: {
                      equals: {
                        value: [3],
                      },
                    },
                  },
                ],
              },
            },
          ],
          excludeBehaviors: [],
          constraints: {
            inOrder: false,
            inSameSession: false,
            platform: 0,
            timeRange: {
              startTime: 'NOW/DAY-29DAY',
              endTime: 'NOW/DAY+1DAY',
            },
            completeSessions: false,
            withinTime: Duration.zero,
            eventThresholds: [],
          },
          excludeConstraints: null,
        },
      },
      segmentMetadata: {
        canned: true,
      },
      metadata: mockAuditMetadata(),
    },
    starred: true,
    lastViewed: null,
  },
  test: {
    segment: {
      segment: {
        id: 'wCLghQJsrj6S',
        name: 'test',
        description: '',
        segmentDefinition: {
          userProperties: [],
          excludeUserProperties: [],
          behaviors: [{ event: { primary: { click: { any: {} } }, deps: [] } }],
          excludeBehaviors: [],
          constraints: {
            inOrder: false,
            inSameSession: false,
            platform: 0,
            timeRange: { startTime: 'NOW/DAY-29DAY', endTime: 'NOW/DAY+1DAY' },
            completeSessions: false,
            withinTime: Duration.zero,
            eventThresholds: [],
          },
          excludeConstraints: null,
        },
      },
      segmentMetadata: null,
      metadata: mockAuditMetadata({
        lastUpdated: '2021-04-02T03:53:15.527645Z' as timestamp,
        lastUpdatedBy: 'timchin@fullstory.com',
        created: '2021-04-02T03:53:15.527645Z' as timestamp,
        createdBy: 'timchin@fullstory.com',
        archived: false,
        version: int64.fromNumber(1617335595527),
        sequentialVersion: int64.fromNumber(1),
      }),
    },
    starred: false,
    lastViewed: '2021-04-02T04:27:42.270Z' as timestamp,
  },
};

export const mockInitialSegmentState: DeepPartial<AppState> = {
  segments: {
    allSegments: [
      'everyone',
      'signedUpUsers',
      'newThisWeek',
      'rageClicks',
      'mobileUsers',
      'test',
      'privateSegment',
    ],
    allSegmentsRequest: {
      loading: false,
      error: false,
      lastRequested: -1,
      lastResponded: -1,
    },
    initialSegmentIds: {
      loading: false,
      error: false,
      data: {
        starred: [
          'signedUpUsers',
          'newThisWeek',
          'rageClicks',
          'mobileUsers',
          'test',
          'privateSegment',
        ],
        recent: [],
      },
    },
    segmentsById: {
      everyone: {
        segment: {
          segment: {
            id: 'everyone',
            name: 'Everyone',
            description: '',
            segmentDefinition: {
              userProperties: [],
              excludeUserProperties: [],
              behaviors: [],
              excludeBehaviors: [],
              constraints: {
                inOrder: false,
                inSameSession: false,
                platform: 0,
                timeRange: {
                  startTime: 'NOW/DAY-29DAY',
                  endTime: 'NOW/DAY+1DAY',
                },
                completeSessions: false,
                withinTime: Duration.zero,
                eventThresholds: [],
              },
              excludeConstraints: null,
            },
          },
          segmentMetadata: {
            canned: true,
          },
          metadata: mockAuditMetadata(),
        },
        starred: false,
        lastViewed: null,
      },
      signedUpUsers: {
        segment: {
          segment: {
            id: 'signedUpUsers',
            name: 'Signed-up',
            description: '',
            segmentDefinition: {
              userProperties: [
                {
                  primary: {
                    signedUp: {
                      signedUp: {
                        value: true,
                      },
                    },
                  },
                },
              ],
              excludeUserProperties: [],
              behaviors: [],
              excludeBehaviors: [],
              constraints: {
                inOrder: false,
                inSameSession: false,
                platform: 0,
                timeRange: {
                  startTime: 'NOW/DAY-29DAY',
                  endTime: 'NOW/DAY+1DAY',
                },
                completeSessions: false,
                withinTime: Duration.zero,
                eventThresholds: [],
              },
              excludeConstraints: null,
            },
          },
          segmentMetadata: {
            canned: true,
          },
          metadata: mockAuditMetadata(),
        },
        starred: true,
        lastViewed: null,
      },
      newThisWeek: {
        segment: {
          segment: {
            id: 'newThisWeek',
            name: 'New this week',
            description: '',
            segmentDefinition: {
              userProperties: [
                {
                  primary: {
                    firstSeen: {
                      range: {
                        value: {
                          startTime: 'NOW/DAY-6DAY',
                          endTime: 'NOW/DAY+1DAY',
                        },
                      },
                    },
                  },
                },
              ],
              excludeUserProperties: [],
              behaviors: [],
              excludeBehaviors: [],
              constraints: {
                inOrder: false,
                inSameSession: false,
                platform: 0,
                timeRange: {
                  startTime: 'NOW/DAY-6DAY',
                  endTime: 'NOW/DAY+1DAY',
                },
                completeSessions: false,
                eventThresholds: [],
                withinTime: Duration.zero,
              },
              excludeConstraints: null,
            },
          },
          segmentMetadata: {
            canned: true,
          },
          metadata: mockAuditMetadata(),
        },
        starred: true,
        lastViewed: null,
      },
      rageClicks: {
        segment: {
          segment: {
            id: 'rageClicks',
            name: 'Rage clicked recently',
            description: '',
            segmentDefinition: {
              userProperties: [],
              excludeUserProperties: [],
              behaviors: [
                {
                  event: {
                    primary: {
                      rageClick: {
                        any: {},
                      },
                    },
                    deps: [],
                  },
                },
              ],
              excludeBehaviors: [],
              constraints: {
                inOrder: false,
                inSameSession: false,
                platform: 0,
                timeRange: {
                  startTime: 'NOW/DAY-6DAY',
                  endTime: 'NOW/DAY+1DAY',
                },
                completeSessions: false,
                withinTime: Duration.zero,
                eventThresholds: [],
              },
              excludeConstraints: null,
            },
          },
          segmentMetadata: {
            canned: true,
          },
          metadata: mockAuditMetadata(),
        },
        starred: true,
        lastViewed: null,
      },
      mobileUsers: {
        segment: {
          segment: {
            id: 'mobileUsers',
            name: 'Mobile',
            description: '',
            segmentDefinition: {
              userProperties: [],
              excludeUserProperties: [],
              behaviors: [
                {
                  event: {
                    primary: null,
                    deps: [
                      {
                        device: {
                          equals: {
                            value: [3],
                          },
                        },
                      },
                    ],
                  },
                },
              ],
              excludeBehaviors: [],
              constraints: {
                inOrder: false,
                inSameSession: false,
                platform: 0,
                timeRange: {
                  startTime: 'NOW/DAY-29DAY',
                  endTime: 'NOW/DAY+1DAY',
                },
                completeSessions: false,
                withinTime: Duration.zero,
                eventThresholds: [],
              },
              excludeConstraints: null,
            },
          },
          segmentMetadata: {
            canned: true,
          },
          metadata: mockAuditMetadata(),
        },
        starred: true,
        lastViewed: null,
      },
      test: {
        segment: {
          segment: {
            id: 'wCLghQJsrj6S',
            name: 'test',
            description: '',
            segmentDefinition: {
              userProperties: [],
              excludeUserProperties: [],
              behaviors: [{ event: { primary: { click: { any: {} } }, deps: [] } }],
              excludeBehaviors: [],
              constraints: {
                inOrder: false,
                inSameSession: false,
                platform: 0,
                timeRange: { startTime: 'NOW/DAY-29DAY', endTime: 'NOW/DAY+1DAY' },
                completeSessions: false,
                withinTime: Duration.zero,
                eventThresholds: [],
              },
              excludeConstraints: null,
            },
          },
          segmentMetadata: null,
          metadata: mockAuditMetadata({
            lastUpdated: '2021-04-02T03:53:15.527645Z' as timestamp,
            lastUpdatedBy: 'timchin@fullstory.com',
            created: '2021-04-02T03:53:15.527645Z' as timestamp,
            createdBy: 'timchin@fullstory.com',
            archived: false,
            version: int64.fromNumber(1617335595527),
            sequentialVersion: int64.fromNumber(1),
          }),
        },
        starred: false,
        lastViewed: '2021-04-02T04:27:42.270Z' as timestamp,
      },
      privateSegment: {
        segment: {
          segment: {
            id: 'privateSegment',
            name: 'privateSegment',
            description: '',
            segmentDefinition: {
              userProperties: [],
              excludeUserProperties: [],
              behaviors: [{ event: { primary: { click: { any: {} } }, deps: [] } }],
              excludeBehaviors: [],
              constraints: {
                inOrder: false,
                inSameSession: false,
                platform: 0,
                timeRange: { startTime: 'NOW/DAY-29DAY', endTime: 'NOW/DAY+1DAY' },
                completeSessions: false,
                withinTime: Duration.zero,
                eventThresholds: [],
              },
              excludeConstraints: null,
            },
          },
          segmentMetadata: null,
          metadata: mockAuditMetadata({
            lastUpdated: '2021-04-02T03:53:15.527645Z' as timestamp,
            lastUpdatedBy: 'timchin@fullstory.com',
            created: '2021-04-02T03:53:15.527645Z' as timestamp,
            createdBy: 'timchin@fullstory.com',
            archived: false,
            version: int64.fromNumber(1617335595527),
            sequentialVersion: int64.fromNumber(1),
            visibility: Visibility.PRIVATE,
          }),
        },
        starred: false,
        lastViewed: '2021-04-02T04:27:42.270Z' as timestamp,
      },
    },
    followedSegments: [
      'everyone',
      'signedUpUsers',
      'newThisWeek',
      'rageClicks',
      'mobileUsers',
      'test',
      'privateSegment',
    ],
    lastKnownSegment: 'everyone',
    access: {
      lastRequested: -1,
      lastResponded: -1,
      loading: false,
      error: false,
      data: null,
    },
  },
};
